import * as Icons from "lucide-react";

// Render a lucide icon by string name from data files
export default function Icon({ name, className = "" }) {
  const Cmp = Icons[name] || Icons.Circle;
  return <Cmp className={className} aria-hidden="true" />;
}
